<template>
  <div 
    v-if="this.demand && this.readyToRender"
    class="container-fluid"
  >
    <router-link 
      :to="{ path: '/demands'}"
      class="see-all"
    >
      <button class="btn btn-complete">Voir tous</button>
    </router-link>

    <h3>Demande de validation</h3>
    
    <!-- {{availableTabs}} -->
    <tabs
      :container-classes="[ 'panel', 'panel-transparent' ]"
      :nav-classes="['nav-tabs-fillup']"
      :store-module="moduleName"
      :key="demand.id"
      @resource-form-data="retreiveDatas($event)"
    >
    </tabs>
  </div>
</template>

<script>
  import Tabs from 'components/Tabs/Tabs'
  import { moduleName, mutations } from 'components/Demands/tabs'
  import { resolveMutation, resolveState } from 'store/modules/tabs/tabManagerFactory'
  import routeWatcher from 'mixins/routeWatcher'
  import routeWatcherTab from 'mixins/routeWatcherTab'
  import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
  import { FETCHING_SWITCH } from 'store/mutation-types'

  export default {
    name: "SimpleDemand",
    props: [
      "demand"
    ],

    components: {
      Tabs
    },

    computed: {
      ...mapState('demands', ['forms', 'demands']),

      get_documents () {
        var tf = _.find(this.forms, (form) => form.main_request.request.id == this.demand.id)
        if (tf)
          return tf.document_types
      },

      get_order () {
        var tf = _.find(this.forms, (form) => form.main_request.request.id == this.demand.id)
        if (tf && tf.main_request && tf.main_request.model_new_version && tf.main_request.model_new_version.order)
          return tf.main_request.model_new_version.order
        return false
      },

      isInSap() {
        var tf = _.find(this.forms, (form) => form.main_request.request.id == this.demand.id)
        if (tf && tf.main_request && tf.main_request.related_models && tf.main_request.related_models.customer)
          return tf.main_request.related_models.customer.stored_in_erp
        return false
      },

      ...mapGetters('demands', ['get_treatment_forms']),

      tabsIndexesToRemove() {
        const indexes = []
        const contractValidationRequestTypes = ['domiciliation-contract-validation', 'office-contract-validation']

        if (!this.get_documents || this.get_documents == 0) {
          indexes.push('step3') // Documents tab
        }

        if (contractValidationRequestTypes.indexOf(this.demand.type.name) === -1) {
          indexes.push('step2') // Customer tab
          indexes.push('step4') // Order tab
        } 
        if (this.demand.type.name != 'domiciliation-contract-validation' || !this.demand.customer.is_subject_to_beneficial_owners_declaration) {
          indexes.push('beneficial-owners-step') // Beneficial owners tab
        }
        if (this.demand.type.name != 'domiciliation-contract-validation') {
          indexes.push('digital-signature-step') // Digital signature tab
          indexes.push('review-requests-step') // Review requests tab
        }

        return indexes
      },

      availableTabs () {
        if (this.tabsIndexesToRemove.length > 0) {
            const tabsIndexes = []

            // Getting indexes of tabs that have to be displayed
            _.forEach(this.moduleState.tabsArray, (tab) => {
                if (this.tabsIndexesToRemove.indexOf(tab.name) === -1) {
                    tabsIndexes.push(_.indexOf(this.moduleState.tabsArray, tab))
                }
            })

            return tabsIndexes
        } else {
          return null
        }
      },
    },

    methods: {
      ...mapActions('demands', ['valideValidation',
        'refuseValidation',
        'getValidationRequests',
        'validationRequestTreatmentForm',
        "set_numerotation", "set_available_idxs",
        "set_current_treating_demand","setActiveTab"
      ]),

      cancel () {
        this.$router.go(-1)
      },

      init () {
        if (!_.find(this.forms, (form) => form.main_request.request.id == this.demand.id))
          this.validationRequestTreatmentForm(this.demand.id)
            .then(() => {
              this.set_available_idxs(this.availableTabs)
              this.readyToRender = true
            })
      }
    },

    data () {
      return {
        moduleName,
        moduleState: resolveState('treatmentDemandTabs', this.$store.state),
        params: {},
        readyToRender: false,
      }
    },

    mounted () {
      this.init()
      this.set_numerotation(true)
      this.set_current_treating_demand(this.demand)
    },

    watch :{
      availableTabs : function () {
        this.set_available_idxs(this.availableTabs)
        this.readyToRender = true
      },
    },

    beforeDestroy()
    {
      this.setActiveTab(0)
    }
  }

</script>
<style>
  .see-all {
    margin-top: 20px;
    float: right;
  }
</style>



// WEBPACK FOOTER //
// client/views/Demands/SimpleDemand.vue